import { Component, OnInit, ElementRef, ChangeDetectorRef, ViewChild, Inject } from '@angular/core';
import { Constants } from '../../utils/constants';
import { formatDate } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { BankProfile } from '../../../components/utils/bank-profile';
import { BankDetailService } from '../../../components/service/bank-detail.service';
import { Router } from '@angular/router';
import { TruckAccountInfo } from '../../../components/utils/truck-account-info';
import { PaymentPayload } from '../../../components/utils/payload';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AssetListResponse } from '../../../shared/models/assetListResponse';
import { PayoffResponseBeanList } from '../../../shared/payoffResponseBeanList';
import { ContractNumberRequest } from '../../../shared/models/contractNumberResponse';
import { AuthorizationService } from '../../authorization/authorization.service';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../../utils/sharedTranslateModule';
import { Banner } from '../../../shared/models/banner';
import { DTFHomepageService } from '../../dtfhomepage/dtfhomepage.service';

import {MatDatepickerModule} from '@angular/material/datepicker';
import { PayComponent } from '../../pay/pay.component';
import { MatIconModule } from '@angular/material/icon';
import { monthlypaymentResponseList } from '../../../shared/models/monthlypaymentResponseList';
import { PayCopyComponent } from '../../pay copy/paycopy.component';
import { WindowRef } from '../../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { PayoffDialogComponent } from '../../payoff/payoff.component';
import { MatRadioModule } from '@angular/material/radio';
import { principalPaymentResponseList } from '../../../shared/models/principalPaymentResponseList';
import { AuthorizeDialogComponent } from '../onlinepayment/onlinepayment.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { AgreementDetailsList } from '../../../shared/models/AgreementDetailsList';
import { MatButtonModule } from '@angular/material/button';
import { provideNativeDateAdapter } from '@angular/material/core';
import { forkJoin } from 'rxjs';
import { monthlypaymentRequestlist } from '../../../../../src/app/shared/models/monthlypaymentRequestlist';
import { executionInterval } from '../../../../../src/app/shared/models/executionInterval';
import { SubscriptionResponseList } from '../../../../../src/app/shared/models/SubscriptionResponseList';
import { Daum } from '../../../../../src/app/shared/models/Daum';
import { CancelSubscriptionResponse } from '../../../../../src/app/shared/models/CancelSubscriptionResponse';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeleteDialogComponent, ScheduledpaymentComponent } from '../scheduledpayment/scheduledpayment.component';
import { SessionTimeoutComponent } from '../../sessionTimeout/sessionTimeout.component';

interface Status {
  value: string;
  viewValue: string;
}

interface Payments {
  value: string;
  viewValue: string;
}

interface Requests {
  value: string;
  viewValue: string;
}

export enum ToggleEnum { //used for mat toggle
  Option0,
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
  Option8,
  Option9,
}

@Component({
    selector: 'div.dtf-recurringpayment',
    templateUrl: './recurringpayment.component.html',
    styles: [],
    providers: [],
    imports: [SharedTranslateModule,SessionTimeoutComponent,
        MatPaginator, MatSort, MatTableModule, MatInputModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule, MatSortModule, MatIconModule, MatRadioModule
    ]
})
export class RecurringpaymentComponent implements OnInit {


  isCheckedRegular: boolean
  isCheckedPrincipal: boolean
  step1DisplayedColumns = ['select', 'amount', 'startDate', 'endDate']
  step2DisplayedColumns = ['Account', 'recurringPaymentAmount', 'recurringStartDate', 'recurringEndDate', 'transacationId', 'status']
  statuses: Status[] = [
    { value: 'active', viewValue: 'ACTIVE' },
    { value: 'expired', viewValue: 'EXPIRED' },
    { value: 'cancel', viewValue: 'CANCELLED' },
  ];
  selectedPayments: Payments[] = [
    {value: 'make payments', viewValue: 'Make a Payment'},
    {value: 'principal payments', viewValue: 'Principal Payment'},
    {value: 'recurring payments', viewValue: 'Recurring Payment'},
    {value: 'statement payments', viewValue: 'Statement Payment'},
    {value: 'payment history', viewValue: 'Payment History'},
    {value: 'manage profile', viewValue: 'Manage Bank Profile'},
    
  ];

  dropDownList: Array<any>=[];

  selectedPayment: string | null = null;
  selectedbutton: string | null = null;
  rowSelected: boolean
  paymentDateError: boolean
  tableData: TruckAccountInfo[];

  paymentType: string;
  endDateError: boolean;
  totalPaymentAmout: any = 0;
  Authorize: any;
  AuthorizeBoolean: boolean;
  modelText: any;
  dtf_Url: any;
  bankDetailObj: BankProfile = new BankProfile;
  selected: any;
  profiles: any;
  loaded: boolean;
  accountList: TruckAccountInfo[];
  paymentPayload: PaymentPayload[] = [];
  pmtDate = new Date();
  emptyAmount: boolean;
  onePaymentBoolean: boolean;
  dueDateError: boolean;
  endDateError2: boolean;
  endDateError3: boolean;
  endDateError4: boolean;
  recurringScheduleError: boolean;
  startDateError1: boolean;
  emptyDate: boolean;
  wrongDate: boolean;
  emptyEndDate: boolean;
  wrongEndDate: boolean;
  amountLimit: boolean;
  oneDayPayment: boolean;
  userAccountInfo:any
  originalData: any;
  agentView: boolean;
  page: string;
  blocked: boolean;
  errmsg: any;
  isFrench = false;
  language = '';
  assetListRes: AssetListResponse[]; 
  payoffResponseBeanList : PayoffResponseBeanList[];
  displaycontractNumberList ='';
  titleAuthNumberList: ContractNumberRequest[];
  token: string;
  rowCount = 0;
  ciamId = sessionStorage.getItem('loginID');
  getMultiPayoffRequest: any ={};
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  terminationDate ='';
  brandId: string;
  recurringpaymenttable2 = false;
  selection = new SelectionModel<monthlypaymentResponseList>(true, []);
  selectionsingle = new SelectionModel<monthlypaymentResponseList>(false, []);
  currentCountry: string;
  public alerts: Banner;
  dbData: any;
  langFlag: string;
  countryFlag: string;
  bodyLoaded = false;
  MonthlyPaymentResponseList: monthlypaymentResponseList[];
  FilteredMonthlyPaymentResponseList: monthlypaymentResponseList[];
  FilteredPrinciplePaymentResponseList: principalPaymentResponseList[];
  thirdParty: string;
  recurringpaymentstep1 = false;
  recurringpaymentstep2 = false;
  recurringpaymentstep3 = false;
  contractSelected = false;
  tableLoaded = true;
  selectedRecurringResponseList: monthlypaymentResponseList[];
  accountSelected = false;
  customerName: string;
  invalidR: boolean=false;
  invaliddate = false;
  minDate: Date;
  maxDate: Date;
  azURL: string;
  usUrl: string;
  caUrl: string;
  trans_history = false;
  regular = true;
  principal = false;
  PrincipalPaymentResponseList: principalPaymentResponseList[];
 
  selectedPrincipalResponseList:principalPaymentResponseList[];
  isChecked = false;
  totalAmount: number = 0;
  totalAmountPr: number = 0;
  principalpayment = false;
  principalpaymentstep1 = false;
  principalpaymentstep2 = false;
  principalpaymentstep3 = false;
  invalidPr: boolean=false;
  required = false;
  amount = false;
  selectone = false;
  OnlinePaymentstep1 = true;
  amount1: number =0;  // Amount entered by the user
  isAmountEntered: boolean = false;  
  autopayerror = false;
  isPcAutopayEnabledRequest: any = {};
  isAP = false;
  isPC = false;
  ifEdit = false;
  currentDate: Date;
  scheduledpayment = false;
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option0;
  accountNumbers = [];
  Editamount = [];
  edate = [];
  getValidAutopayAccountsRequest: any = {};
  signUp = false;
  editFlag = false;
  agreementDetailsList: AgreementDetailsList[];
  call1 = false;
  call2 = false;
  dtpayCustomerId: String = "";
  dtpayPaymentMethodToken: String = '';
  lineitemsList: monthlypaymentRequestlist;
  line_items: monthlypaymentRequestlist[];
  reference: string;
  status: string;
  executionInterval: executionInterval;
  exec_Interval: executionInterval[];
  subscriptionResponseList: SubscriptionResponseList[];
  step1 = true;
  regularpayment = false;
  subscriptionList: Daum[];
  selectedHistoricalResponseList: Daum[];
  CancelSubscriptionSuccess = false;
  showerror = false;
  CancelSubscriptionData: CancelSubscriptionResponse[];
  Cancelid: string;
  selectedDateRange: { start: Date | null; end: Date | null } = { start: null, end: null };
  duplicateAgreementNumbers: string[] = [];
  firstDoRegularPayment = false;
  warningMessage: string = '';
  showWarning = false;
  agentview: string;
  failureError = false;
  baseRedirect = '';
  dtpayMaskedAccountNumber: String = "";
  

 

  initColumns1: any[] = [
    {
      name: 'line_items[0].description',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'line_items[0].unit_price',
      display: 'Payment Amount',
      dispFormat: 'monthlyamountdue'
    },
    {
      name: 'execution_interval.start_date',
      display: 'Start Date',
      dispFormat: 'date1'
    },
    {
      name: 'execution_interval.end_date',
      display: 'End Date',
      dispFormat: 'date2'
    },
    {
      name: 'reference',
      display: 'Transaction Id',
      dispFormat: 'transaction'
    },
    {
      name: 'status',
      display: 'Status',
      dispFormat: 'status'
    }
  ];
  displayedColumns1: any[] = this.initColumns1.map(col => col.name);
  
  initPrincipalPaymentColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'agreementNumber',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'principalAmount',
      display: 'Principal Amount',
      dispFormat: 'principalamount'
    },
    {
      name: 'recurringStartDate',
      display: 'Start Date',
      dispFormat: 'date'
    },
    {
      name: 'endDate',
      display: 'End Date',
      dispFormat: 'date1'
    }
  ];
  displayedPrinicpalPaymentColumns: any[] = this.initPrincipalPaymentColumns.map(col => col.name);

   initPrincipalPaymentColumns2: any[] = [
    {
      name: 'agreementNumber',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'principalAmount',
      display: 'Principal Amount',
      dispFormat: 'principalamount'
    },
    {
      name: 'recurringStartDate',
      display: 'Start Date',
      dispFormat: 'date'
    },
    {
      name: 'endDate',
      display: 'End Date',
      dispFormat: 'date'
    }
  ];
  displayedPrinicpalPaymentColumns2: any[] = this.initPrincipalPaymentColumns2.map(col => col.name);

  initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: 'select'
    },
    {
      name: 'line_items[0].description',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'line_items[0].unit_price',
      display: 'Payment Amount',
      dispFormat: 'paymentamount'
    },
    {
      name: 'execution_interval.start_date',
      display: 'Start Date',
      dispFormat: 'date1'
    },
    {
      name: 'execution_interval.end_date',
      display: 'End Date',
      dispFormat: 'date2'
    },
    {
      name: 'reference',
      display: 'Transaction Id',
      dispFormat: 'transaction'
    },
    {
      name: 'status',
      display: 'Status',
      dispFormat: 'status'
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  CancelSubinitColumns: any[] = [
    {
      name: 'line_items[0].description',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'calculated_amounts.gross_order_total',
      display: 'Payment Amount',
      dispFormat: 'paymentamount'
    },
    {
      name: 'execution_interval.start_date',
      display: 'Start Date',
      dispFormat: 'date1'
    },
    {
      name: 'execution_interval.end_date',
      display: 'End Date',
      dispFormat: 'date2'
    },
     {
      name: 'reference',
      display: 'Transaction Id',
      dispFormat: 'transaction'
    },
    {
      name: 'status',
      display: 'Status',
      dispFormat: 'status'
    }
  ];
  displayedColumnsCancelSub: any[] = this.CancelSubinitColumns.map(col => col.name);

  initRecurringColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'agreementNumber',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'nextPaymentDue',
      display: 'Monthly Amount Due',
      dispFormat: 'monthlyamountdue'
    },
    {
      name: 'amountRecurring',
      display: 'Payment Amount',
      dispFormat: 'paymentamount'
    },
    {
      name: 'recurringStartDate',
      display: 'Start Date',
      dispFormat: 'startdate'
    },
    {
      name: 'endDate',
      display: 'End Date',
      dispFormat: 'enddate'
    }
  ];
  displayedRecurringColumns: any[] = this.initRecurringColumns.map(col => col.name);

  initRecurringColumnsStep2: any[] = [
    {
      name: 'agreementNumber',
      display: 'Account Number',
      dispFormat: 'acct'
    },
    {
      name: 'nextPaymentDue',
      display: 'Monthly Amount Due',
      dispFormat: 'monthlyamountdue'
    },
    {
      name: 'amountRecurring',
      display: 'Payment Amount',
      dispFormat: 'paymentamount'
    },
    {
      name: 'recurringStartDate',
      display: 'Start Date',
      dispFormat: 'startdate'
    },
    {
      name: 'endDate',
      display: 'End Date',
      dispFormat: 'enddate'
    }
  ];
  displayedRecurringColumnsStep2: any[] = this.initRecurringColumnsStep2.map(col => col.name);

 

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  selectionPr = new SelectionModel<principalPaymentResponseList>(true, []);
  selectionHis = new SelectionModel<Daum>(true, []);
  dataSource: MatTableDataSource<monthlypaymentResponseList>;
  PrincipalDatasource: MatTableDataSource<principalPaymentResponseList>;
  datasourceAutoPay: MatTableDataSource<AgreementDetailsList>;
  subscriptionDataSource: MatTableDataSource<SubscriptionResponseList>;
  HistoricalSubscriptionDataSource: MatTableDataSource<Daum>;
  CancelSubscriptionDataSource: MatTableDataSource<CancelSubscriptionResponse>;


  constructor(private cdr: ChangeDetectorRef, private router: Router, private bankDetailService: BankDetailService, public auth: AuthorizationService,private dtfhomepageService: DTFHomepageService, private _window: WindowRef, public translate: TranslateService, public dialog: MatDialog) {
    this.MonthlyPaymentResponseList =[];
    this.subscriptionResponseList = [];
    this.subscriptionList = [];
    this.selectedHistoricalResponseList = [];
    this.FilteredMonthlyPaymentResponseList = [];
    this.dataSource = new MatTableDataSource(this.FilteredMonthlyPaymentResponseList);
    this.FilteredPrinciplePaymentResponseList = [];
    this.PrincipalDatasource = new MatTableDataSource(this.FilteredPrinciplePaymentResponseList);
    this.PrincipalPaymentResponseList = [];
    this.PrincipalDatasource = new MatTableDataSource(this.PrincipalPaymentResponseList);
    this.agreementDetailsList = [];
    this.CancelSubscriptionData = [];
    this.line_items = [];
    this.exec_Interval = [];
    this.datasourceAutoPay = new MatTableDataSource(this.agreementDetailsList);
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.minDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+1);
    this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
   }

  ngOnInit(): void {
    this.langInit();
    this.customerName = sessionStorage.getItem('customerName');
    this.thirdParty = sessionStorage.getItem('thirdPartyNumber');
    this.onLoad();
    this.token = sessionStorage.getItem('ciamToken');
    this.isPcAutopayEnabled();
    // if(sessionStorage.getItem('agentView')=="true"){
    //   this.agentView=true
    // }else{
    //  this.agentView=false
    // }
    this.agentview = sessionStorage.getItem('agentview');
    this.page=sessionStorage.getItem('page')
    
   // this.dtf_Url = environment.dtf_Url
   // this.validateUser()
   this.isFrench = ('fr-CA' === this.language) ? true : false; 
   
    //this.accounts();

    const language = (window as any).mbfs.language;
    this.language= language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
  
    //this.getAlerts();

  }

   langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.baseRedirect = this.usUrl + '/ca/en/';
    } else if (this.language === 'fr-CA') {
        this.baseRedirect = this.usUrl + '/ca/fr/';
    } else {
        this.baseRedirect = this.usUrl;
    }
    this.isFrench = ('fr-CA' === this.language) ? true : false; //checks if language is french or english for Canada
  }


  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;
    
    if (this.selectedState === 1) {
      this.azURL =  this.usUrl + '/home/principalpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 2) {
      this.azURL =  this.usUrl + '/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 3) {
      this.azURL =  this.usUrl + '/home/statementpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 4) {
      this.azURL =  this.usUrl + '/home/bankprofile';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 6) {
      this.azURL =  this.usUrl + '/home/recurringpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 7) {
      this.azURL =  this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 8) {
      this.azURL =  this.usUrl + '/home/help';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    } 
  }

  onLoad(){
    this.dropDownList=[];
    const request = {
      "thirdPartyId" : this.thirdPartyNumber,
       "userId" : this.ciamId
    }
      this.auth.bankProfile(request).subscribe(res => {
       if(res.length==0){     
              sessionStorage.setItem('online-page-navigation', "Online-Payment")
              sessionStorage.setItem('userExist',"true")
              this.router.navigate(['/home/addprofile']);
            }else{
              sessionStorage.setItem('userExist',"false")
              this.profiles=res;
      
            this.profiles.forEach((element: any) => {
              let option=element.bankName+" "+element.maskedAccountNumber.substr(element.maskedAccountNumber.length - 4)
              let obj={selection: option, id:element.id}
              // if(element["saveProfile"]){
                this.dropDownList.push(obj);
              //   }
                this.selected=this.dropDownList[0]["id"];
            })
            this.cdr.detectChanges();
            this.bankDetailObj=this.profiles[0];
            this.bankDetailService.setObject(this.bankDetailObj);
            this.dtpayCustomerId = this.bankDetailObj.dtpay_customer_id;
            this.dtpayPaymentMethodToken = this.bankDetailObj.dtpay_payment_method_token;
            this.dtpayMaskedAccountNumber=this.bankDetailObj.maskedAccountNumber;
            this.loaded=true;

            this.subscriptionsList();
          }
       
      }, error=>{ 
         if(error.status){
           this.loaded=true;
         }
    });
    }
 
    onChange(){
      let index=this.profiles.findIndex((obj:any)=>obj.id===this.selected)
      this.bankDetailObj=this.profiles[index];
      this.bankDetailService.setObject(this.bankDetailObj);
      this.dtpayCustomerId = this.bankDetailObj.dtpay_customer_id;
      this.dtpayPaymentMethodToken = this.bankDetailObj.dtpay_payment_method_token;
    }

    getSelectedBankName(): string {
      const selectedBank = this.dropDownList.find(opt => opt.id === this.selected);
      return selectedBank ? selectedBank.selection : '';  // Return the bank name or an empty string if not found
    }

  

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public disableCheckbox(): boolean {
    return this.selectionsingle.selected.length >= 1;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  accounts(){
    this.tableLoaded = false;
    const thirdpartyRequest = {
      "thirdPartyNumber": this.thirdParty,
      "brandId":2,
      "ciamId":this.ciamId
    };

    const getODSThirdPartyAccountSummary$ = this.auth.getODSThirdPartyAccountSummary(thirdpartyRequest);
    
    this.getValidAutopayAccountsRequest = {
      signUp: false,
      editFlag: true,
      ciamId: this.ciamId,
      ciamAZCode: this.token,
    };

    const getValidAutopayAccounts$ = this.auth.getValidAutopayAccounts(this.getValidAutopayAccountsRequest);

    // Use forkJoin to combine both requests and wait until both are completed
    forkJoin([getODSThirdPartyAccountSummary$, getValidAutopayAccounts$]).subscribe(
      ([odsResponse, autopayResponse]) => {
        // First API Response - Processing MonthlyPaymentResponseList
        this.MonthlyPaymentResponseList = odsResponse;
        const today = new Date();
        for (let i = 0; i < this.MonthlyPaymentResponseList.length; i++) {
          // this.MonthlyPaymentResponseList[i].agreementNumber = this.MonthlyPaymentResponseList[i].agreementNumber + '001';

          if (parseInt(this.MonthlyPaymentResponseList[i].amountRecurring) < 0) {
            this.MonthlyPaymentResponseList[i].amountRecurring = "0.00";
          }
          this.MonthlyPaymentResponseList[i].amountRecurring = parseFloat(this.MonthlyPaymentResponseList[i].amountRecurring).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });

          const contractEndDate = new Date(this.MonthlyPaymentResponseList[i].endDate);
          this.maxDate[this.MonthlyPaymentResponseList[i].agreementNumber] = contractEndDate;
          
          this.MonthlyPaymentResponseList[i].recurringStartDate = new Date(this.MonthlyPaymentResponseList[i].recurringStartDate);

          this.MonthlyPaymentResponseList[i].endDate = new Date(this.MonthlyPaymentResponseList[i].endDate);
        }

        // this.dataSource = new MatTableDataSource(this.MonthlyPaymentResponseList);
        // this.dataSource.paginator = this.paginator;
        // this.dataSource.sort = this.sort;

        // Second API Response - Processing agreementDetailsList
        if (autopayResponse.statusMessage === 'SUCCESS') {
          this.agreementDetailsList = autopayResponse.agreementDetailsList;
            this.autopayerror = true;
            this.datasourceAutoPay = new MatTableDataSource(this.agreementDetailsList);
            setTimeout(() => {
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
              this.rowCount = this.dataSource.filteredData.length;
            });       
        }
        this.cdr.detectChanges();
        // After both API calls have completed, filter the MonthlyPaymentResponseList
        this.filterUniqueMonthlyPayments();
      },
      (error) => {
        console.error('Error in API requests:', error);
      }
    );
    this.tableLoaded = true;
  }



  filterUniqueMonthlyPayments() {
    // Assuming `agreementNumber` is the unique identifier to check for duplicates
    if (this.agreementDetailsList && Array.isArray(this.agreementDetailsList)) {
      const agreementNumbersInAutopay = this.agreementDetailsList.map(item => item.agreementNumber);

      // Remove duplicates from MonthlyPaymentResponseList based on agreementNumber
      this.FilteredMonthlyPaymentResponseList = this.MonthlyPaymentResponseList.filter(item => {
        return !agreementNumbersInAutopay.includes(item.agreementNumber);
      });

      this.dataSource = new MatTableDataSource(this.FilteredMonthlyPaymentResponseList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.rowCount = this.FilteredMonthlyPaymentResponseList.length;
    }
  }



  radiobuttonclicked(){
    if(this.selectedbutton == "Regular"){
      this.accounts();
      this.selection.clear();
      this.selectionPr.clear();
      this.regularpayment = true;
      this.regular = true;
      this.recurringpaymentstep1=true;
      this.recurringpaymentstep2= false;
      this.recurringpaymentstep3= false;
      this.principalpayment = false;
    }else if(this.selectedbutton == "Principal"){
      this.PrincipalAccount();
      this.selection.clear();
      this.selectionPr.clear();
      this.principalpayment = true;
      this.principal =true;
      this.principalpaymentstep1 = true;
      this.principalpaymentstep2 = false;
      this.principalpaymentstep3 = false;
      this.regularpayment = false;
    }
  }

  calculateTotalAmount(): void {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected < 1){
    this.totalAmount = 0;
   }else {
    this.totalAmount = 0;
    for(var i = 0; i < this.selection.selected.length; i++ ){
    this.selection.selected[i].amountRecurring = this.selection.selected[i].amountRecurring.replace(/[^0-9.-]+/g, '');
    this.totalAmount += parseFloat(this.selection.selected[i].amountRecurring);
    }
    this.totalAmount = parseFloat(this.totalAmount.toFixed(2));
  }
   
  }
  positiveNumberOnly(event): boolean {
    const pattern = /[0-9.,]/;  // Allow only digits, comma, and decimal point
    if (!pattern.test(event.key)) {
      event.preventDefault();
    }

    const charCode = (event.which) ? event.which : event.keyCode;
    if(charCode == 45)
      return false;
      return true;
  }

convertToDecimal(element) {
  // Remove non-numeric characters (except dot and minus)
  let rawValue = element.amountRecurring ? element.amountRecurring.toString().replace(/[^0-9.-]+/g, '') : '';

  // Handle empty or invalid input
  let numericValue = parseFloat(rawValue);
  if (isNaN(numericValue) || rawValue === '') {
    numericValue = 0;
  }

  // Update the data source
  let index = this.dataSource.data.findIndex(
    (obj: any) => obj.agreementNumber === element.agreementNumber
  );

  // Format and assign back
  this.dataSource.data[index].amountRecurring = this.addComma(numericValue.toFixed(2));

  // Recalculate totals
  this.calculateTotalAmount();
}

  addComma(value: string): string {
    let [integerPart, decimalPart] = value.split('.');
  
    // Add commas to the integer part (before the decimal point)
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    // Join the integer part with the decimal part (if any)
    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
  }


  onSubmit() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    this.invalidR = false;
    this.amount = false;
    this.invaliddate = false;
    this.accountSelected = true;
    this.selectone = false;
    this.required = false;

    // Check for invalid amountRecurring
    for (let i = 0; i < this.selection.selected.length; i++) {
      let amountRecurring = parseFloat(this.selection.selected[i].amountRecurring);
      if (amountRecurring === 0 || amountRecurring > 2000000) {
        this.invalidR = true;
        this.amount = true;
      }
    }

    // Check if totalAmount exceeds 1,000,000
    if (this.totalAmount > 2000000) {
      this.invalidR = true;
      this.amount = true;
    }

    // Check if a valid number of rows are selected (between 1 and 11)
    if (numSelected < 1 || numSelected > 11) {
      this.invalidR = true;
      this.selectone = true;
      this.accountSelected = false;
    }

    // Date validation
    this.selection.selected.forEach(item => {
      if (item.recurringStartDate && item.endDate) {
        const recurringStartDate = new Date(item.recurringStartDate);
        const endDate = new Date(item.endDate);

        // If paymentDate is after endDate or endDate is before paymentDate, show error
        if (recurringStartDate > endDate || endDate < recurringStartDate) {
          this.invalidR = true;
          this.invaliddate = true;
        }
      }
    });

    // If historical payment exist show error 
    for (let i = 0; i < this.selection.selected.length; i++) {
      console.log(this.subscriptionList);

      const selectedAgreementNumber = this.selection.selected[i].agreementNumber;

      if (selectedAgreementNumber) {
        const exists = this.subscriptionList.some(sub =>
          sub.status === 'ACTIVE' &&
          sub.payment_settings?.metadata?.payment_type === 'AGREEMENT' &&
          sub.line_items?.some(line_item => line_item.description === selectedAgreementNumber) &&
          sub.execution_interval.start_date !== sub.execution_interval.end_date
        );

        if (exists) {
          this.invalidR = true;

          console.log(this.duplicateAgreementNumbers);

          if (!this.duplicateAgreementNumbers.includes(selectedAgreementNumber)) {
            this.duplicateAgreementNumbers.push(selectedAgreementNumber);
          }
        }
      }
    }

    // Check if required fields and button selections are valid
    if (!this.selected || !this.selectedbutton) {
      this.invalidR = true;
      this.required = true;
    }

    // If there are errors, prevent submission
    if (this.invalidR) {
      console.log("Form is invalid, not submitting.");
      return;
    }

    // If no errors, proceed with the steps
    this.step1 = false;
    this.regularpayment = true;
    this.recurringpaymentstep1 = false;
    this.recurringpaymentstep2 = true;
    this.recurringpaymentstep3 = false;
    this.scheduledpayment = false;
    this.principalpaymentstep2 = false;
    this.principalpaymentstep3 = false;
    this.principalpaymentstep1 = false;
    this.principalpayment = false;

    // Proceed with the logic
    this.checkToggleSelected();

    // Log values for debugging
    console.log("dtpayCustomerIdpayoff", this.dtpayCustomerId);
    console.log("dtpayPaymentMethodTokenpayoff", this.dtpayPaymentMethodToken);
  }


  // Scheduled(){
  //  this.scheduledpayment = true;
  //  this.recurringpaymentstep1 = false;
  //  this.step1 = false;
  //  this.regularpayment = false;
  //  this.principalpayment = false;

  //  if(this.selection.selected){

  //  }
  
  //  this.subscriptionsList();
  
  // }

  // subscriptionsList(){
  //   const request = {
  //   "customer_id": this.dtpayCustomerId,
  //  }

  //   this.auth.subscriptionsList(request).subscribe(res => {
  //     this.subscriptionList = res.data;
  //     console.log("getSubscriptions Response",this.subscriptionList);
  //     this.HistoricalSubscriptionDataSource = new MatTableDataSource(this.subscriptionList);
  //         setTimeout(() => {
  //           this.HistoricalSubscriptionDataSource.paginator = this.paginator;
  //           this.HistoricalSubscriptionDataSource.sort = this.sort;
  //           this.rowCount = this.HistoricalSubscriptionDataSource.filteredData.length;
  //     });
  //   });
  // }

  Scheduled() {
  this.scheduledpayment = true;
  this.recurringpaymentstep1 = false;
  this.step1 = false;
  this.regularpayment = false;
  this.principalpayment = false;

  let selectedAgreementNumbers: string[] = [];

  if (this.selection && this.selection.selected.length > 0) {
    selectedAgreementNumbers = selectedAgreementNumbers.concat(
      this.selection.selected.map(item => item.agreementNumber)
    );
  }

  if (this.selectionPr && this.selectionPr.selected.length > 0) {
    selectedAgreementNumbers = selectedAgreementNumbers.concat(
      this.selectionPr.selected.map(item => item.agreementNumber)
    );
  }

  // No deduplication here

  this.subscriptionsList(selectedAgreementNumbers.length > 0 ? selectedAgreementNumbers : undefined);
}

subscriptionsList(agreementNumbersFilter?: string[]) {
  const request = {
    "customer_id": this.dtpayCustomerId,
  };

  this.auth.subscriptionsList(request).subscribe(res => {
    let subscriptionList = res.data;

    // If there's a filter, apply it to the subscriptionList
    if (agreementNumbersFilter && agreementNumbersFilter.length > 0) {
      subscriptionList = subscriptionList.filter(sub => 
        agreementNumbersFilter.includes(sub.line_items?.[0]?.description)
      );
    }

    this.subscriptionList = subscriptionList;
    console.log("getSubscriptions Response", this.subscriptionList);
    this.HistoricalSubscriptionDataSource = new MatTableDataSource(this.subscriptionList);
    this.HistoricalSubscriptionDataSource.sortingDataAccessor = (item: any, property: string) => {
      if (property === 'status') {
        switch (item.status?.toLowerCase()) {
          case 'active':
            return 1;
          case 'cancelled':   // ✅ match actual status value
            return 2;
          case 'expired':
            return 3;
          default:
            return 99;
        }
      }

      return (item as any)[property];
    };
    this.cdr.detectChanges();
    setTimeout(() => {
      this.HistoricalSubscriptionDataSource.paginator = this.paginator;
      this.HistoricalSubscriptionDataSource.sort = this.sort;
      this.rowCount = this.HistoricalSubscriptionDataSource.filteredData.length;
      this.sort.active = 'status';
      this.sort.direction = 'asc';
      this.sort.sortChange.emit();
    });
  });
}


  applyStatusFilter(status: string) {

  if (!status) {
    // Reset filter if no status selected
    this.HistoricalSubscriptionDataSource.data = this.subscriptionList;
    return;
  }

  const filteredData = this.subscriptionList.filter(item => {
    if (status === 'active') {
      return item.status === 'ACTIVE';
    } else if (status === 'expired') {
      return item.status === 'EXPIRED';
    }else if (status === 'cancel') {
      return item.status === 'CANCELLED';
    }
    return true;
  });
   this.HistoricalSubscriptionDataSource.filter = status;
    if (this.HistoricalSubscriptionDataSource.paginator) {
      this.HistoricalSubscriptionDataSource.paginator.firstPage();
    }
    this.rowCount = this.HistoricalSubscriptionDataSource.filteredData.length;

}

applyFilterAcc(input: string) {
  this.HistoricalSubscriptionDataSource.filterPredicate = (data: Daum, filter: string) => {
    if (!filter) return true;

    return data.line_items?.some(item =>
      item.description?.toLowerCase().includes(filter)
    );
  };

  input = input.trim().toLowerCase();
  this.HistoricalSubscriptionDataSource.filter = input;

  if (this.HistoricalSubscriptionDataSource.paginator) {
    this.HistoricalSubscriptionDataSource.paginator.firstPage();
  }

  this.rowCount = this.HistoricalSubscriptionDataSource.filteredData.length;
}



onDateRangeChange(event: any) {
  const range = this.selectedDateRange;

  if (!range?.start || !range?.end) {
    this.HistoricalSubscriptionDataSource.filter = '';
    return;
  }

  // Strip time from selected start and end dates
  const startDate = this.normalizeDate(range.start);
  const endDate = this.normalizeDate(range.end);

  this.HistoricalSubscriptionDataSource.filterPredicate = (data: Daum, filter: string) => {
    const exec = data.execution_interval;
    if (!exec || (!exec.start_date && !exec.end_date)) return false;

    const execStart = exec.start_date ? this.normalizeDate(new Date(exec.start_date)) : null;
    const execEnd = exec.end_date ? this.normalizeDate(new Date(exec.end_date)) : null;

    const isStartInRange = execStart && execStart >= startDate && execStart <= endDate;
    const isEndInRange = execEnd && execEnd >= startDate && execEnd <= endDate;

    return isStartInRange || isEndInRange;
  };

  this.HistoricalSubscriptionDataSource.filter = `${Math.random()}`;

  if (this.HistoricalSubscriptionDataSource.paginator) {
    this.HistoricalSubscriptionDataSource.paginator.firstPage();
  }

  this.rowCount = this.HistoricalSubscriptionDataSource.filteredData.length;
}

normalizeDate(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()); // sets time to 00:00:00
}


  Back2recpay(){
    window.location.reload();
    this.recurringpaymentstep1 = true;
  }

  convertToDecimalPr(element) {
  // Remove non-numeric characters (except dot and minus)
  let rawValue = element.principalAmount ? element.principalAmount.toString().replace(/[^0-9.-]+/g, '') : '';

  // Handle empty or invalid input
  let numericValue = parseFloat(rawValue);
  if (isNaN(numericValue) || rawValue === '') {
    numericValue = 0;
  }

  // Update the data source
  let index = this.PrincipalDatasource.data.findIndex(
    (obj: any) => obj.agreementNumber === element.agreementNumber
  );

  // Format and assign back
  this.PrincipalDatasource.data[index].principalAmount = this.addComma(numericValue.toFixed(2));

  // Recalculate totals
  this.calculateTotalAmountPr();
}


  checkToggleSelected(){
    this.selectedRecurringResponseList = [];
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if (numSelected < 1) {
      this.auth.SetErrorMessage('Please select at least one account');
    }
    else {
      this.accountSelected = true;
    }
    for (var i = 0; i < this.selection.selected.length; i++) {
     this.selectedRecurringResponseList = this.selection.selected;
     this.dataSource = new MatTableDataSource(this.selectedRecurringResponseList);
     this.dataSource.paginator = null;
     this.dataSource.sort = this.sort;
    }
  }


  back2step1(){
    window.location.reload();
    this.recurringpaymentstep1 = true;
    this.recurringpaymentstep2 = false;
  }

  RecurringPaymentAuthorize(){
    this.opendialog();
  }

  opendialog(){
    const dialogRef = this.dialog.open(AuthorizeDialogComponent, {
      data: { amount1: this.totalAmount, agentView: this.agentView }  
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result) {
        
        this.isAmountEntered = true;
        this.recurringpaymentstep1 = false;
        this.recurringpaymentstep2 = false;
        this.recurringpaymentstep3 = true;
        this.tableLoaded = false;
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;

        const selectedRows = this.selection.selected;

         
        this.selection.selected.forEach((row, index) => {

          this.lineitemsList = new monthlypaymentRequestlist();
          this.lineitemsList.position = 1;
          this.lineitemsList.dollarAmount = parseFloat(row.amountRecurring.replace(/[^0-9.-]+/g, ''));
          this.lineitemsList.alfa_agreement_number = row.agreementNumber;

          this.line_items.push(this.lineitemsList);

          this.executionInterval = new executionInterval();
          this.executionInterval.start_date = formatDate(row.recurringStartDate, 'yyyy-MM-dd', 'en-US');
          this.executionInterval.end_date = formatDate(row.endDate, 'yyyy-MM-dd', 'en-US');
          this.executionInterval.interval = "MONTHLY";

          this.exec_Interval.push(this.executionInterval);

        });

        const request = {
          userId: this.ciamId,
          maskedAccountNumber: this.dtpayMaskedAccountNumber,
          "type": "RECURRING",
          "customer_id": this.dtpayCustomerId,
          "payment_type": "AGREEMENT",
          "payment_settings": {
          "payment_method": {
            "token": this.dtpayPaymentMethodToken,
            "type": "FIRST_PAYMENT"   
          }
          },
          "line_items": this.line_items,
          "executionIntervalList": this.exec_Interval
        }

        console.log("Monthly Payment Request",request);

        this.auth.subscriptions(request).subscribe(res => {
          if (res.statusMessage === "FAILURE") {
            this.failureError = true;
            this.recurringpaymentstep1 = false;
            this.recurringpaymentstep2 = false;
            this.recurringpaymentstep3 = true;
          }
        console.log("subscriptions Response",res);
        this.subscriptionResponseList = res;

         for(var i=0; i< this.subscriptionResponseList.length; i++){
            if(res[i].status == "ACTIVE"){
            this.subscriptionResponseList[i].status = "IN PROCESS"
            }
         }
          
          this.subscriptionDataSource = new MatTableDataSource(this.subscriptionResponseList);
          this.tableLoaded = true;
          this.cdr.detectChanges();
          setTimeout(() => {
            this.subscriptionDataSource.paginator = this.paginator;
            this.subscriptionDataSource.sort = this.sort;
            this.rowCount = this.subscriptionDataSource.filteredData.length;
            this.cdr.detectChanges();
          });
      });
    }
    });
  }

 

  Remove(){
    this.checkToggleSelectedHis();
    const numSelected = this.selectionHis.selected.length;
    if (numSelected < 1 || numSelected > 1) {
      this.showerror = true;
    }else{
       this.Removepopup();
    }
  }

  isTerminateDisabled(): boolean {
    return this.selectionHis?.selected?.some(item =>
      ['expired', 'cancelled'].includes(item.status?.toLowerCase())
    );
  }



  Removepopup(){
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: {}  
    });
   
    dialogRef.afterClosed().subscribe(result => {
      if (result) {    
        
        this.tableLoaded = false;
        const numSelected = this.selectionHis.selected.length;
        const numRows = this.HistoricalSubscriptionDataSource.data.length;

        const selectedRows = this.selectionHis.selected;

        this.selectionHis.selected.forEach((row, index) => {
          this.Cancelid = row.id;
        });

        const request = {
          userId: this.ciamId,
          "id": this.Cancelid
        }

        this.auth.cancelSubscription(request).subscribe(res => {
          this.CancelSubscriptionData = [res];        
          console.log(this.CancelSubscriptionData);
          if (res) {
            this.tableLoaded = true;
            this.CancelSubscriptionSuccess = true;
            this.scheduledpayment = false;
          }
          this.CancelSubscriptionDataSource = new MatTableDataSource(this.CancelSubscriptionData);
          this.cdr.detectChanges();
          setTimeout(() => {
            this.CancelSubscriptionDataSource.paginator = this.paginator;
            this.CancelSubscriptionDataSource.sort = this.sort;
            this.rowCount = this.CancelSubscriptionDataSource.filteredData.length;
          });
        });
       
      }else{
        window.location.reload();
      }
    });
  }

  CancelledSubscription(){
   this._window.nativeWindow.location.href = '/home/recurringpayment';
  }

  checkToggleSelectedHis(){
    this.selectedHistoricalResponseList = [];
    for (var i = 0; i < this.selectionHis.selected.length; i++) {
     this.selectedHistoricalResponseList = this.selectionHis.selected;
    }
    this.HistoricalSubscriptionDataSource = new MatTableDataSource(this.selectedHistoricalResponseList);
    this.HistoricalSubscriptionDataSource.paginator = this.paginator;
    this.HistoricalSubscriptionDataSource.sort = this.sort;
    console.log(this.selectedHistoricalResponseList);
  }

  BacktoDashBoard(){
    this._window.nativeWindow.location.href = '/home/dashboard';
  }

  DownloadPdf() {
    const doc = new jsPDF({ format: 'a4' });
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    var base64Img =
        'data:image/jpeg;base64,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';
      if (base64Img) {
        doc.addImage(base64Img, 'JPEG', pageWidth - 195, 15, 50, 10);
      }

    var Header = [];
    Header = [
      ["Agreement Number", "Payment Amount", "Start Date", "End Date","Transaction id", "Status"]
    ];
  
   
    var rows = [];
    const head = Header;
    const data = this.subscriptionResponseList;
  
    // Loop through data and prepare rows
    data.forEach(element => {
      var temp = [element.line_items[0].description, `$${parseFloat(element.line_items[0].alfa_agreement_number).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, element.execution_interval.start_date, element.execution_interval.end_date, element.reference, element.status];
      rows.push(temp);
    });
  
    // Table Configuration
    const marginTop = 40; // Top margin where the table starts
    const rowHeight = 10; // Height of each row in the table (adjust as needed)
    const headerHeight = 10; // Height of the header row
  
    // Add the table
    autoTable(doc,{
      head: head,
      body: rows,
      theme: 'grid',
      headStyles: { fillColor: [79, 77, 74] },
      margin: { top: marginTop }, // Start the table below the verbiage
    });
  
    // Calculate the total height of the table based on rows
    const tableHeight = (rows.length * rowHeight) + headerHeight; // Height of all rows plus the header
    const tableBottomY = marginTop + tableHeight;
  
    // Add footer text or additional verbiage below the table
    doc.setFontSize(12);
    
    // Wrap "Thank you for your payment." text
    const thankYouText = this.translate.instant('onlinepayment.auth');
    const maxWidth = 190; // Adjust this based on your document width
    const wrappedThankYouText = doc.splitTextToSize(thankYouText, maxWidth);
  
    // Add wrapped text
    let currentY = tableBottomY + 10; // Starting Y position for wrapped text
    wrappedThankYouText.forEach(line => {
      doc.text(line, 14, currentY);
      currentY += 6; // Adjust the line spacing as needed
    });
  
    // Add new paragraph with bold first word and checkbox
    const nextParagraphY = currentY + 10; // Position for next paragraph
  
    // Bold the first word in the paragraph
    doc.setFont("Arial", "bold");
    doc.text('Notice:', 14, nextParagraphY ); // First word in bold
  
    // Switch to regular font for the rest of the paragraph
    doc.setFont("Arial", "normal");
  
    // Text to wrap
    const paragraphText = 'The entry of a future dated payment transaction shall not be deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or an amendment to the payment due dates in my lease, retail installment contract or promissory note and security agreement.';
    
    // Split the text to fit the width
    const wrappedText = doc.splitTextToSize(paragraphText, maxWidth);
  
    // Add each line of wrapped text to the PDF
    let currentTextY = nextParagraphY + 5; // Starting Y position for the wrapped text
    wrappedText.forEach(line => {
      doc.text(line, 14, currentTextY);
      currentTextY += 6; // Adjust line spacing as needed
    });
  
    const checkboxX = 14;
    const checkboxY = currentTextY + 5;
    const checkboxSize = 5;

    // Draw the checkbox (square)
    doc.rect(checkboxX, checkboxY, checkboxSize, checkboxSize);

    // Draw a tick mark inside the checkbox
    doc.setLineWidth(0.5);
    doc.setDrawColor(0); // black tick
    // Draw the tick manually as two lines
    doc.line(checkboxX + 1, checkboxY + checkboxSize / 2, checkboxX + 2, checkboxY + checkboxSize - 1); // short stroke
    doc.line(checkboxX + 2, checkboxY + checkboxSize - 1, checkboxX + checkboxSize - 1, checkboxY + 1); // long stroke

    // Add label next to the checkbox
    doc.setFont("Arial", "normal");
    doc.text('I have read and accept the terms of the above Authorization Statement.', checkboxX + checkboxSize + 3, checkboxY + checkboxSize - 1);
  

    this.addHeaderFooters(doc)
    // Save the document as a PDF
    doc.save('Receipt.pdf');

  }

  DownloadPdfPr() {
    const doc = new jsPDF({ format: 'a4' });
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    var base64Img =
        'data:image/jpeg;base64,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';
      if (base64Img) {
        doc.addImage(base64Img, 'JPEG', pageWidth - 195, 15, 50, 10);
      }
      doc.setFont('Arial', 'bold');
      doc.text('Customer Name:', 15, 45);
      doc.setFont('Arial', 'normal');
      doc.text(this.customerName, 45, 45);

    var Header = [];
    Header = [
      ["Agreement Number", "Payment Amount", "Start Date", "End Date","Transaction id", "Status"]
    ];
  
   
    var rows = [];
    const head = Header;
    const data = this.subscriptionResponseList;

  
    // Loop through data and prepare rows
    data.forEach(element => {
      var temp = [element.line_items[0].description, `$${parseFloat(element.line_items[0].alfa_agreement_number).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, element.execution_interval.start_date, element.execution_interval.end_date, element.reference, element.status];
      rows.push(temp);
    });
  
    // Table Configuration
    const marginTop = 40; // Top margin where the table starts
    const rowHeight = 10; // Height of each row in the table (adjust as needed)
    const headerHeight = 10; // Height of the header row
  
    // Add the table
    autoTable(doc,{
      head: head,
      body: rows,
      theme: 'grid',
      headStyles: { fillColor: [79, 77, 74] },
      margin: { top: marginTop }, // Start the table below the verbiage
    });
  
    // Calculate the total height of the table based on rows
    const tableHeight = (rows.length * rowHeight) + headerHeight; // Height of all rows plus the header
    const tableBottomY = marginTop + tableHeight;
  
    // Add footer text or additional verbiage below the table
    doc.setFontSize(12);
    
    // Wrap "Thank you for your payment." text
    const thankYouText = this.translate.instant('onlinepayment.auth');
    const maxWidth = 190; // Adjust this based on your document width
    const wrappedThankYouText = doc.splitTextToSize(thankYouText, maxWidth);
  
    // Add wrapped text
    let currentY = tableBottomY + 10; // Starting Y position for wrapped text
    wrappedThankYouText.forEach(line => {
      doc.text(line, 14, currentY);
      currentY += 6; // Adjust the line spacing as needed
    });
  
    // Add new paragraph with bold first word and checkbox
    const nextParagraphY = currentY + 10; // Position for next paragraph
  
    // Bold the first word in the paragraph
    doc.setFont("Arial", "bold");
    doc.text('Notice:', 14, nextParagraphY ); // First word in bold
  
    // Switch to regular font for the rest of the paragraph
    doc.setFont("Arial", "normal");
  
    // Text to wrap
    const paragraphText = 'The entry of a future dated payment transaction shall not be deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or an amendment to the payment due dates in my lease, retail installment contract or promissory note and security agreement.';
    
    // Split the text to fit the width
    const wrappedText = doc.splitTextToSize(paragraphText, maxWidth);
  
    // Add each line of wrapped text to the PDF
    let currentTextY = nextParagraphY + 5; // Starting Y position for the wrapped text
    wrappedText.forEach(line => {
      doc.text(line, 14, currentTextY);
      currentTextY += 6; // Adjust line spacing as needed
    });
  
    const checkboxX = 14;
    const checkboxY = currentTextY + 5;
    const checkboxSize = 5;

    // Draw the checkbox (square)
    doc.rect(checkboxX, checkboxY, checkboxSize, checkboxSize);

    // Draw a tick mark inside the checkbox
    doc.setLineWidth(0.5);
    doc.setDrawColor(0); // black tick
    // Draw the tick manually as two lines
    doc.line(checkboxX + 1, checkboxY + checkboxSize / 2, checkboxX + 2, checkboxY + checkboxSize - 1); // short stroke
    doc.line(checkboxX + 2, checkboxY + checkboxSize - 1, checkboxX + checkboxSize - 1, checkboxY + 1); // long stroke

    // Add label next to the checkbox
    doc.setFont("Arial", "normal");
    doc.text('I have read and accept the terms of the above Authorization Statement.', checkboxX + checkboxSize + 3, checkboxY + checkboxSize - 1);
  

    this.addHeaderFooters(doc)
    // Save the document as a PDF
    doc.save('Receipt.pdf');

  }
  
  addHeaderFooters = (doc) => {
    const pageCount = doc.internal.getNumberOfPages();
    const pageWidth = doc.internal.pageSize.width;
    let translate = this.translate;

    doc.setFont('Arial', 'Normal');
    doc.setFontSize(8);


    for (var i = 1; i <= pageCount; i++) {

      //Pagination
      doc.setPage(i);
      doc.text('Page ' + String(i) + ' of ' + String(pageCount),
        pageWidth / 2, 279, {
        align: 'center',
      }
      );

      if (i <= 2 || i == pageCount) {
        // sign  
        doc.text(translate.instant('Payoff.payofffooter_line1'), pageWidth - 72, 270, { align: 'left' });
        doc.text(translate.instant('Payoff.payofffooter_line2'), pageWidth - 72, 274, { align: 'left' });
        doc.text(translate.instant('Payoff.payofffooter_line3'), pageWidth - 72, 278, { align: 'left', });
        doc.text(translate.instant('Payoff.payofffooter_line4'), pageWidth - 72, 282, { align: 'left', });
        doc.text(translate.instant('Payoff.payofffooter_line5'), pageWidth - 72, 286, { align: 'left' }
        );
      }
    }

  };
  
  setuprecurringpayments(){
    this.recurringpaymenttable2 = true;
  }

  PrincipalAccount(){
    this.tableLoaded = false;
    const thirdpartyRequest = {
      "thirdPartyNumber": this.thirdParty,
      "brandId":2,
      "type":"Principal",
      "ciamId":this.ciamId
    };

    const getODSThirdPartyAccountSummary$ = this.auth.getODSThirdPartyAccountSummary(thirdpartyRequest);
    
    this.getValidAutopayAccountsRequest = {
      signUp: false,
      editFlag: true,
      ciamId: this.ciamId,
      ciamAZCode: this.token,
    };

    const getValidAutopayAccounts$ = this.auth.getValidAutopayAccounts(this.getValidAutopayAccountsRequest);

    // Use forkJoin to combine both requests and wait until both are completed
    forkJoin([getODSThirdPartyAccountSummary$, getValidAutopayAccounts$]).subscribe(
      ([odsResponse, autopayResponse]) => {
        // First API Response - Processing MonthlyPaymentResponseList
        this.PrincipalPaymentResponseList = odsResponse;
        const today = new Date();
      for (var i = 0; i < this.PrincipalPaymentResponseList.length; i++) {
        // this.PrincipalPaymentResponseList[i].agreementNumber = this.PrincipalPaymentResponseList[i].agreementNumber + '001';

        this.PrincipalPaymentResponseList[i].principalAmount = parseFloat(this.PrincipalPaymentResponseList[i].principalAmount).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2});

        let daysPastDue = parseInt(this.PrincipalPaymentResponseList[i].daysPastDue);
        if (isNaN(daysPastDue) || daysPastDue < 0) {
          daysPastDue = 0;
        }

        let remainingDays = 60 - daysPastDue;
        if (remainingDays < 0) remainingDays = 0;

        const maxAllowedDate = new Date(today);
        maxAllowedDate.setDate(today.getDate() + remainingDays);

        const contractEndDate = new Date(this.PrincipalPaymentResponseList[i].endDate);
        
        // Extract year, month, and day
        const year = contractEndDate.getFullYear();
        const month = contractEndDate.getMonth();  // Note: zero-based month (0 = January)
        const day = contractEndDate.getDate();

        // Create new Date object with time set to midnight
        const formattedDate = new Date(year, month, day);

        if (formattedDate <= maxAllowedDate) {
          this.maxDate[this.PrincipalPaymentResponseList[i].agreementNumber] = contractEndDate;
        } else {
          this.maxDate[this.PrincipalPaymentResponseList[i].agreementNumber] = maxAllowedDate;
        }
        this.PrincipalPaymentResponseList[i].endDate = new Date(this.PrincipalPaymentResponseList[i].endDate);
        this.PrincipalPaymentResponseList[i].recurringStartDate = new Date(this.PrincipalPaymentResponseList[i].recurringStartDate);
      }
        if (autopayResponse.statusMessage === 'SUCCESS') {
          this.agreementDetailsList = autopayResponse.agreementDetailsList;
            this.autopayerror = true;
            this.datasourceAutoPay = new MatTableDataSource(this.agreementDetailsList);
            setTimeout(() => {
              this.PrincipalDatasource.paginator = this.paginator;
              this.PrincipalDatasource.sort = this.sort;
              this.rowCount = this.dataSource.filteredData.length;
            });
          
        }

        // After both API calls have completed, filter the MonthlyPaymentResponseList
        this.filterUniquePrinciplePayments();
        this.calculateTotalAmountPr();
      },
      (error) => {
        console.error('Error in API requests:', error);
      }
    );
    this.cdr.detectChanges();
    this.tableLoaded = true;
  }

filterUniquePrinciplePayments() {

  // 🔹 Safety check
  if (!Array.isArray(this.PrincipalPaymentResponseList)) {
    this.FilteredPrinciplePaymentResponseList = [];
    this.showWarning = true;
    return;
  }

  // 🔹 Get autopay agreement numbers
  const agreementNumbersInAutopay = (this.agreementDetailsList || [])
    .map(item => item?.agreementNumber)
    .filter(Boolean);

  // 🔹 Get active regular subscriptions (AGREEMENT type only)
  const validAgreementNumbers = (this.subscriptionList || [])
    .filter(sub =>
      sub?.status === 'ACTIVE' &&
      sub?.payment_settings?.metadata?.payment_type === 'AGREEMENT'
    )
    .map(sub => sub?.line_items?.[0]?.description)
    .filter(Boolean);

  // 🔹 Filter principal accounts
  // ✅ Show account if it exists in Autopay OR Active Regular Recurring
  this.FilteredPrinciplePaymentResponseList =
    this.PrincipalPaymentResponseList.filter(item => {

      const agreementNumber = item?.agreementNumber;

      const isInRegularSchedule =
        validAgreementNumbers.includes(agreementNumber);

      const isInAutopay =
        agreementNumbersInAutopay.includes(agreementNumber);

      return isInRegularSchedule || isInAutopay;
    });

  // 🔹 Show warning if nothing eligible
  this.showWarning = this.FilteredPrinciplePaymentResponseList.length === 0;

  if (this.showWarning) {
    this.warningMessage =
      `Please Note: None of your accounts are eligible for principal recurring payments. ` +
      `To schedule principal recurring payment, enroll in AutoPay or set up a regular recurring payment for your accounts.`;
  }

  // 🔹 Update table datasource
  this.PrincipalDatasource =
    new MatTableDataSource(this.FilteredPrinciplePaymentResponseList);

  this.PrincipalDatasource.paginator = this.paginator;
  this.PrincipalDatasource.sort = this.sort;

  this.rowCount = this.FilteredPrinciplePaymentResponseList.length;
}


  calculateTotalAmountPr(): void {
    const numSelected = this.selectionPr.selected.length;
    const numRows = this.PrincipalDatasource.data.length;
    if(numSelected < 1){
    this.totalAmountPr = 0;
   }else {
    this.totalAmountPr = 0;
    for(var i = 0; i < this.selectionPr.selected.length; i++ ){
    this.selectionPr.selected[i].principalAmount = this.selectionPr.selected[i].principalAmount.replace(/[^0-9.-]+/g, '');
    this.totalAmountPr += parseFloat(this.selectionPr.selected[i].principalAmount);
    }
    this.totalAmountPr = parseFloat(this.totalAmountPr.toFixed(2));
  }
  }

 restrictToTwoDecimals(event: KeyboardEvent, currentValue: string) {
  const input = event.target as HTMLInputElement;
  const key = event.key;

  // Allow navigation and editing keys
  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight' ||
    key === 'Tab' ||
    key === 'Home' ||
    key === 'End'
  ) {
    return;
  }

  // Allow only digits and decimal point
  if (!/[0-9.]/.test(key)) {
    event.preventDefault();
    return;
  }

  const { selectionStart, selectionEnd, value } = input;
  const start = selectionStart ?? 0;
  const end = selectionEnd ?? 0;

  // Simulate what the input value would look like after this keypress
  const newValue = value.slice(0, start) + key + value.slice(end);

  // If there’s more than one dot, block
  if ((newValue.match(/\./g) || []).length > 1) {
    event.preventDefault();
    return;
  }

  // Check if there are more than 2 digits after the decimal
  const parts = newValue.split('.');
  if (parts.length === 2 && parts[1].length > 2) {
    event.preventDefault();
    return;
  }
}

  onSubmitPr() {
    const numSelected = this.selectionPr.selected.length;
    const numRows = this.PrincipalDatasource.data.length;
    this.invalidPr = false;
    this.amount = false;
    this.invaliddate = false;
    this.accountSelected = true; // default value
    this.selectone = false; // default value
    this.required = false; // default value

    // Check for invalid principal amount and total amount
    for (let i = 0; i < this.selectionPr.selected.length; i++) {
      let principalAmount = parseFloat(this.selectionPr.selected[i].principalAmount);
      if (principalAmount === 0 || principalAmount > 2000000) {
        this.invalidPr = true;
        this.amount = true;
      }
    }

    if (this.totalAmountPr > 2000000) {
      this.invalidPr = true;
      this.amount = true;
    }

    // Check if valid number of rows are selected (between 1 and 11)
    if (numSelected < 1 || numSelected > 11) {
      this.invalidPr = true;
      this.selectone = true;
      this.accountSelected = false;
    }

    // Date validation (after all other checks)
    this.selectionPr.selected.forEach(item => {
      if (item.recurringStartDate && item.endDate) {
        const recurringStartDate = new Date(item.recurringStartDate);
        const endDate = new Date(item.endDate);

        // If paymentDate is after endDate or endDate is before paymentDate, show error
        if (recurringStartDate > endDate || endDate < recurringStartDate) {
          this.invalidPr = true;
          this.invaliddate = true;
        }
      }
    });

    // Check for historical payment existence and payment_type validation
    for (let i = 0; i < this.selectionPr.selected.length; i++) {
      const selectedAgreementNumber = this.selectionPr.selected[i].agreementNumber;

      if (selectedAgreementNumber) {
        // Filter ACTIVE subscriptions for this agreement number
        // and where start_date !== end_date
        const filteredSubscriptions = this.subscriptionList.filter(sub =>
          sub.status === 'ACTIVE' &&
          sub.line_items?.some(item => item.description === selectedAgreementNumber) &&
          sub.execution_interval?.start_date &&
          sub.execution_interval?.end_date &&
          sub.execution_interval.start_date !== sub.execution_interval.end_date
        );

        let foundInAgreement = false;
        let foundInPrinciple = false;

        filteredSubscriptions.forEach(sub => {
          const paymentChannel = sub.payment_settings?.metadata?.payment_type;

          if (paymentChannel === 'AGREEMENT') {
            foundInAgreement = true;
          } else if (paymentChannel === 'PRINCIPLE') {
            foundInPrinciple = true;
          }
        });

        // Add to duplicateAgreementNumbers based on logic
        if (foundInPrinciple) {
          this.invalidPr = true;

          if (!this.duplicateAgreementNumbers.includes(selectedAgreementNumber)) {
            this.duplicateAgreementNumbers.push(selectedAgreementNumber);
          }
        }

        // if (!foundInAgreement) {
        //   this.invalidPr = true;
        //   this.firstDoRegularPayment = true;
        // }
        // Do nothing if found only in AGREEMENT
      }
    }


    // Check for required fields and valid button selection
    if (!this.selected || !this.selectedbutton) {
      this.invalidPr = true;
      this.required = true;
    }

    // If no errors, proceed with steps
    if (!this.invalidPr && this.selected && this.accountSelected && this.selectedbutton && !this.amount && !this.invaliddate) {
      this.step1 = false;
      this.regularpayment = false;
      this.recurringpaymentstep1 = false;
      this.recurringpaymentstep2 = false;
      this.recurringpaymentstep3 = false;
      this.scheduledpayment = false;
      this.principalpaymentstep2 = true;
      this.principalpaymentstep3 = false;
      this.principalpaymentstep1 = false;
      this.principalpayment = true;

      // Call checkToggleSelectedPr if needed
      this.checkToggleSelectedPr();

      // Log values for debugging
      console.log("dtpayCustomerIdpayoff", this.dtpayCustomerId);
      console.log("dtpayPaymentMethodTokenpayoff", this.dtpayPaymentMethodToken);
    }
  }

  

  // checkToggleSelectedPr(){
  //   this.selectedPrincipalResponseList = [];
  //   for (var i = 0; i < this.selectionPr.selected.length; i++) {
  //    this.selectedPrincipalResponseList = this.selectionPr.selected;
  //   }
  //   this.PrincipalDatasource = new MatTableDataSource(this.selectedPrincipalResponseList);
  //   this.PrincipalDatasource.paginator = this.paginator;
  //   this.PrincipalDatasource.sort = this.sort;
  // }

  checkToggleSelectedPr() {
  // Simply assign all selected items to selectedPrincipalResponseList
  this.selectedPrincipalResponseList = [...this.selectionPr.selected]; // clone array to avoid reference issues

  // Update the data source with the full selected list
  this.PrincipalDatasource = new MatTableDataSource(this.selectedPrincipalResponseList);

  // Set paginator and sort as usual
  this.PrincipalDatasource.paginator = null;
  this.PrincipalDatasource.sort = this.sort;
}



  back2step1Pr(){
    window.location.reload();
    this.principalpaymentstep2 = false;
    this.principalpayment = true;
    this.principalpaymentstep1 = true;
    this.OnlinePaymentstep1 = true;
  }

  PrincipalPaymentAuthorize(){
   this.opendialog1();
  }

  opendialog1(){
    const dialogRef = this.dialog.open(AuthorizeDialogComponent, {
      data: { amount1: this.totalAmountPr, agentView: this.agentView }  
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {    
        
        

        this.isAmountEntered = true;
        this.principalpaymentstep3 = true;
        this.principalpaymentstep2 = false;
        this.principalpayment = true;
        this.principalpaymentstep1 = false;
        this.OnlinePaymentstep1 = false;
        this.tableLoaded = false;
        
        const numSelected = this.selectionPr.selected.length;
        const numRows = this.dataSource.data.length;
      

        const selectedRows = this.selectionPr.selected;

         
        this.selectionPr.selected.forEach((row, index) => {

          this.lineitemsList = new monthlypaymentRequestlist();
          this.lineitemsList.position = 1;
          this.lineitemsList.dollarAmount = parseFloat(row.principalAmount.replace(/[^0-9.-]+/g, ''));
          this.lineitemsList.alfa_agreement_number = row.agreementNumber;

          this.line_items.push(this.lineitemsList);

          this.executionInterval = new executionInterval();
          this.executionInterval.start_date = formatDate(row.recurringStartDate, 'yyyy-MM-dd', 'en-US');
          this.executionInterval.end_date = formatDate(row.endDate, 'yyyy-MM-dd', 'en-US');
          this.executionInterval.interval = "MONTHLY";

          this.exec_Interval.push(this.executionInterval);

        });

        const request = {
          userId: this.ciamId,
          maskedAccountNumber: this.dtpayMaskedAccountNumber,
          "type": "RECURRING",
          "customer_id": this.dtpayCustomerId,
          "payment_type": "PRINCIPLE",
          "payment_settings": {
          "payment_method": {
            "token": this.dtpayPaymentMethodToken,
            "type": "FIRST_PAYMENT"   
          }
          },
          "line_items": this.line_items,
          "executionIntervalList": this.exec_Interval
        }

        console.log("Monthly Payment Request",request);

        this.auth.subscriptions(request).subscribe(res => {
          if (res.statusMessage === "FAILURE") {
            this.failureError = true;
            this.principalpaymentstep3 = true;
            this.principalpaymentstep2 = false;
            this.principalpayment = true;
            this.principalpaymentstep1 = false;
            this.OnlinePaymentstep1 = false;
          }
          console.log("subscriptions Response",res);
          this.subscriptionResponseList = res;

         for(var i=0; i< this.subscriptionResponseList.length; i++){
            if(res[i].status == "ACTIVE"){
            this.subscriptionResponseList[i].status = "IN PROCESS"
            }
         }
          this.tableLoaded = true;
          
          this.subscriptionDataSource = new MatTableDataSource(this.subscriptionResponseList);
          this.cdr.detectChanges();
          setTimeout(() => {
            this.subscriptionDataSource.paginator = this.paginator;
            this.subscriptionDataSource.sort = this.sort;
            this.rowCount = this.subscriptionDataSource.filteredData.length;
            this.cdr.detectChanges();
          });
        });
      }
    });
  }



  isPcAutopayEnabled() {
    sessionStorage.removeItem('skipterminate');
    this.isPcAutopayEnabledRequest = {};
    this.isPcAutopayEnabledRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
    };
    this.auth.isPcAutopayEnabled(this.isPcAutopayEnabledRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.isAP = res.autoPayEnabled;
        this.isPC = res.pcenabled;
      }
      if (this.isPC == false ){
        this.autopayerror = true;
      }
      this.cdr.detectChanges();
    });
  }

  isAllSelectedPr() {
    const numSelected = this.selectionPr.selected.length;
    const numRows = this.PrincipalDatasource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterTogglePr() {
    this.isAllSelectedPr() ?
      this.selectionPr.clear() :
      this.PrincipalDatasource.data.forEach(row => this.selectionPr.select(row));
  }
 
 

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }

}

